// extracted by mini-css-extract-plugin
module.exports = {"container":"_38p0sRni","article":"_3D96x7WR","title":"_226NF0Jk","image":"_2rt9OLnB","content":"K0tCWrTQ","category":"_2YqbwLci"};